import { Injectable } from '@angular/core';
import { Listing } from '@df/catalog-ui/listing/listing';
import { IsBannerPluginService } from '@df/catalog-ui/listing/plugin/banner/is-banner-plugin.service';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { IN_STOCK_FILTER_ID } from './filter/stock/filter-stock';

@Injectable({
    providedIn: 'root'
})
export class IsBannerPluginServiceDecorator extends IsBannerPluginService {
    protected onListingUpdate(listing: Listing): void {
        if (
            listing.type === 'product' &&
            (this.isFiltered(listing) || this.isSorted(listing) || !(listing.config.source?.type === 'category'))
        ) {
            listing.setFinalModels(this.purify(listing.getFinalModels() as Product<IProductDataV2>[]));
        }
    }

    /**
     * If any filter is applied check
     */
    isFiltered(listing: Listing): boolean {
        return !!listing.filters.find(filter => filter.hasSelection && filter.id !== IN_STOCK_FILTER_ID);
    }
}
